<template>
  <div class="quest-ans mb-5 mx-auto">
    <div tabindex="0"
         :aria-label="getOptionAriaLabel(index, option)"
         v-for="(option, index) in questionOptions"
         :key="option.id"
         @click="selectOption(index, option.value, option.id)"
         @keyup.enter.space="selectOption(index, option.value, option.id)">
      <div class="quest-name"
        :class="{
          'disabled-answer': isQuestionAnswered && !option.value && option.id !== selectedOptionId,
          'correct-answer': isQuestionAnswered && option.value,
          'wrong-answer': isQuestionAnswered && !option.value && option.id === selectedOptionId,
          'unselected-answer': !isQuestionAnswered
        }">
          {{ $t(option.nameLocalizationKey) }}
      </div>
    </div>
    <aria-live-region :message="message"></aria-live-region>
  </div>
</template>

<script>
import { Storage, UtilsI18n } from '../../../core/Utils'
import AriaLiveRegion from "./AriaLiveRegion"

export default{
  name: "QuestionAnswer",
  components: { AriaLiveRegion },
  data() {
    return {
      isQuestionAnswered: false,
      message: "",
      selectedOptionId: -1,
    }
  },
  props: {
    questionOptions: {
      type: Array,
      required: true,
    },
    questionId: {
      type: Number,
      required: true,
    },
    questionNumber: {
      type: Number,
      required: true
    },
  },
  methods: {
    init: function() {
      this.isQuestionAnswered = false
      this.message = ""
      this.selectedOptionId = -1
      const answers = Storage.getAnswers()
      if (answers && answers.length) {
        if (this.questionNumber <= answers.length) {
          const answer = answers[this.questionNumber - 1]
          if (answer) {
            this.selectOption(answer['id'], answer['value'], answer['optionId'])
          }
        } else if (this.questionNumber > answers.length + 1) {
          // go to last unanswered question
          this.$router.push({ name: "Quiz", params: {questionNumber: (answers.length + 1).toString()}})
        }
      }
    },
    getOptionAriaLabel: function(index, option) {
      return UtilsI18n.interpolateString(this.$t("question_option_aria_label"), {number: index + 1, option: this.$t(option.nameLocalizationKey)})
    },
    selectOption: function (index, isCorrectOption, optionId) {
      if (!this.isQuestionAnswered) {
        this.isQuestionAnswered = true
        this.selectedOptionId = optionId

        if (isCorrectOption) {
          this.message = this.$t("question_correct_feedback")
        } else {
          const number = this.questionOptions.findIndex(o => o.value) + 1
          this.message = UtilsI18n.interpolateString(this.$t("question_incorrect_feedback"), {number})
        }

        const answer = {
          id: this.questionId,
          value: isCorrectOption,
          optionId: optionId
        }

        const answers = Storage.getAnswers()

        if (answers == null) {
          Storage.setAnswers([answer])
        } else if (answers.length === this.questionNumber - 1) {
          // only push if this is the next unanswered question
          answers.push(answer)
          Storage.setAnswers(answers)
        }
        this.$emit('questionAnswered')
      }
    },
  },
  mounted(){
    this.init()
  },
  watch: {
    '$route.params.questionNumber': {
      handler: function() {
        this.init()
      }
    },
  }
}
</script>

<style lang="stylus" scoped>
  @import "~@/core/Styles/variables.styl"

  .quest-ans
    margin-top 80px

  .quest-name
    cursor default
    background color-white
    font-weight 600
    color color-black
    font font-opensans-sem
    padding 18px
    margin-top 20px
    border: solid 2px color-gris-dark
    border-radius: 8px

    &.unselected-answer
      cursor pointer
      &:hover
        border: solid 2px #5E4FB2

    &.correct-answer
      background color-lime-green
      border: solid 2px color-lime-green

    &.wrong-answer
      background color-gris-dark

    &.disabled-answer
      color #757575

</style>
